import { buildForwardCurveSymbol, DataTransformEnums } from 'dashboard-services/api/dataTransform';

const getMonthlyDatePeriod = ({ date, dateFormat }) => {
  const dateValue = String(date),
        sourceDateMatch = dateValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/),
        isoDateMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/),
        isSourceDate = dateFormat === "MM/dd/yyyy" || dateFormat === "MM/DD/YYYY" || !!sourceDateMatch,
        match = isSourceDate ? sourceDateMatch : isoDateMatch
  if(!match) {
    return undefined
  }
  const [, first, second, third] = match,
        month = isSourceDate ? first : second,
        day = isSourceDate ? second : third,
        year = isSourceDate ? third : first,
        parsedDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)))
  if(parsedDate.getUTCFullYear() !== Number(year) || parsedDate.getUTCMonth() !== Number(month) - 1 || parsedDate.getUTCDate() !== Number(day)) {
    return undefined
  }
  return `${year}${month}`
}

const getCurveSymbolPeriod = ({ date, dateFormat, index, isRelative, periodType }) => {
  if(String(isRelative) === "true") {
    return index + 1
  }
  if(periodType === DataTransformEnums.PERIOD_TYPE.MONTH) {
    const parsedDate = getMonthlyDatePeriod({ date, dateFormat })
    if(!parsedDate) {
      return undefined
    }
    return parsedDate
  }
  return date
}

export const buildCurveSymbol = ({ date, dateFormat, index, isRelative, periodType = DataTransformEnums.PERIOD_TYPE.MONTH, root, symbolSize }) => {
  const relative = String(isRelative) === "true"
  if(!root || relative && index === undefined || !relative && !date) {
    return undefined
  }

  const period = getCurveSymbolPeriod({ date, dateFormat, index, isRelative: relative, periodType })
  if(period === undefined) {
    return undefined
  }
  if(relative && symbolSize !== undefined && symbolSize !== "" && period > Number(symbolSize)) {
    return undefined
  }

  return buildForwardCurveSymbol({ root, isRelative: relative ? "true" : "false", periodType, period })
}
